import React from 'react';

import { Heading, Stack } from '@eluve/components';
import { SourceArtifactPendingReviewList } from '@eluve/frontend-feature-eval';

export const SourceArtifactPendingReviewListPage: React.FC = () => {
  return (
    <div>
      <Stack direction="horizontal" align="center" gap={4}>
        <div className="my-2 py-2">
          <Heading className="flex-1">Source Artifacts Pending Review</Heading>
        </div>
      </Stack>
      <SourceArtifactPendingReviewList />
    </div>
  );
};
